import { combineReducers } from 'redux';
import { createDuck } from 'helpers/duckTools';
import api from 'store/actions/api';

import { getCmsContent } from './resultSelector';

export const STORE_KEY = 'cmsSeoTemplate';
export const CMS_KEY = 'cms';

export const cmsDuck = createDuck(
  `${STORE_KEY}/${CMS_KEY}`,
  {
    result: {},
    error: null,
    isLoading: false,
    isLoaded: false,
  },
  {
    loaders: {
      load: {
        fetch: api.getSeoPage,
        resultSelector: getCmsContent,
      },
    },
  },
);

const reducer = combineReducers({
  [CMS_KEY]: cmsDuck,
});

reducer.key = STORE_KEY;

export { reducer };
